// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"96":"fAQ","343":"onboarding","425":"levelup","473":"trade","486":"orders","535":"login","631":"contact","997":"apidocs"}[chunkId] + "." + {"96":"23a5a4b3","343":"8032aed4","425":"b8a36968","473":"cc6661d1","486":"9f81a199","535":"1dfdf3a5","631":"fb474604","997":"03d253d3"}[chunkId] + ".js";
};